import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import PageTitle from "../pages/pageTitle";
import axios from "axios";
import ContactForm from "../cards/contactForm";
import MailSubscription from "../cards/emailSub";
import parse from "html-react-parser";
import { PageLoader } from "../../utils/loader";
import LoaderIcon from "../../utils/loader";
import CareerApplicationForm from "../cards/careerAppForm";
import { formatDateWithTime } from "../cards/recentJobCard";
import { Helmet } from "react-helmet-async";

const JobOpeningDetail = () => {
    const { slug } = useParams();
    const [detail, setDetails] = useState<any>([]);

    // const dataCheck = !detail || detail.length === 0;
    // const companyInfo = useContext(CompanyInfoContext);
    const [loading, setLoading] = useState(true);

    //Modal
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => setShow(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/our-jobs/` + slug
                );
                setDetails(response.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                // Set loading to false once the API call is complete (whether it succeeded or failed)
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    return (
        <>
            <Helmet>
                <title>{`${detail.title} - Codehub Technologies`}</title>
            </Helmet>

            <PageTitle title={detail.job_title} />
            <div className="cht-max-w-4xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-12 sm:cht-py-16 !cht-font-body">
                {/* Position Summary Card */}
                <div className="cht-bg-white cht-rounded-[24px] cht-border cht-border-slate-200/80 cht-shadow-soft cht-p-6 sm:cht-p-10 cht-mb-8">
                    <h3 className="cht-text-xl sm:cht-text-2xl cht-font-bold !cht-font-heading cht-text-[#1e293b] cht-mb-6 cht-border-b cht-border-slate-100 cht-pb-4">
                        Role Overview
                    </h3>
                    <div className="cht-grid sm:cht-grid-cols-2 cht-gap-4">
                        {detail.date_created && (
                            <div className="cht-bg-slate-50/60 cht-rounded-xl cht-p-4 cht-border cht-border-slate-100">
                                <span className="cht-block cht-text-xs cht-font-semibold cht-text-slate-500 cht-uppercase cht-tracking-wider cht-mb-1">
                                    Date Posted
                                </span>
                                <span className="cht-text-sm sm:cht-text-base cht-font-medium cht-text-[#1e293b]">
                                    {formatDateWithTime(detail.date_created)}
                                </span>
                            </div>
                        )}

                        {detail.deadline && (
                            <div className="cht-bg-slate-50/60 cht-rounded-xl cht-p-4 cht-border cht-border-slate-100">
                                <span className="cht-block cht-text-xs cht-font-semibold cht-text-slate-500 cht-uppercase cht-tracking-wider cht-mb-1">
                                    Application Deadline
                                </span>
                                <span className="cht-text-sm sm:cht-text-base cht-font-medium cht-text-[#1e293b]">
                                    {formatDateWithTime(detail.deadline)}
                                </span>
                            </div>
                        )}

                        {detail.number_of_openings && (
                            <div className="cht-bg-slate-50/60 cht-rounded-xl cht-p-4 cht-border cht-border-slate-100">
                                <span className="cht-block cht-text-xs cht-font-semibold cht-text-slate-500 cht-uppercase cht-tracking-wider cht-mb-1">
                                    Available Openings
                                </span>
                                <span className="cht-text-sm sm:cht-text-base cht-font-medium cht-text-[#1e293b]">
                                    {detail.number_of_openings}
                                </span>
                            </div>
                        )}

                        {detail.years_of_experience && (
                            <div className="cht-bg-slate-50/60 cht-rounded-xl cht-p-4 cht-border cht-border-slate-100">
                                <span className="cht-block cht-text-xs cht-font-semibold cht-text-slate-500 cht-uppercase cht-tracking-wider cht-mb-1">
                                    Required Experience
                                </span>
                                <span className="cht-text-sm sm:cht-text-base cht-font-medium cht-text-[#1e293b]">
                                    {detail.years_of_experience}
                                </span>
                            </div>
                        )}

                        {detail.location && (
                            <div className="cht-bg-slate-50/60 cht-rounded-xl cht-p-4 cht-border cht-border-slate-100">
                                <span className="cht-block cht-text-xs cht-font-semibold cht-text-slate-500 cht-uppercase cht-tracking-wider cht-mb-1">
                                    Location
                                </span>
                                <span className="cht-text-sm sm:cht-text-base cht-font-medium cht-text-[#1e293b]">
                                    {detail.location}
                                </span>
                            </div>
                        )}

                        {detail.qualification && (
                            <div className="cht-bg-slate-50/60 cht-rounded-xl cht-p-4 cht-border cht-border-slate-100">
                                <span className="cht-block cht-text-xs cht-font-semibold cht-text-slate-500 cht-uppercase cht-tracking-wider cht-mb-1">
                                    Qualification
                                </span>
                                <span className="cht-text-sm sm:cht-text-base cht-font-medium cht-text-[#1e293b]">
                                    {detail.qualification}
                                </span>
                            </div>
                        )}

                        {detail.skills && (
                            <div className="cht-bg-slate-50/60 cht-rounded-xl cht-p-4 cht-border cht-border-slate-100 sm:cht-col-span-2">
                                <span className="cht-block cht-text-xs cht-font-semibold cht-text-slate-500 cht-uppercase cht-tracking-wider cht-mb-1">
                                    Required Skills
                                </span>
                                <span className="cht-text-sm sm:cht-text-base cht-font-medium cht-text-[#1e293b]">
                                    {detail.skills}
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Roles and Responsibilities Card */}
                {detail.roles && (
                    <div className="cht-bg-white cht-rounded-[24px] cht-border cht-border-slate-200/80 cht-shadow-soft cht-p-6 sm:cht-p-10 cht-mb-10">
                        <h3 className="cht-text-xl sm:cht-text-2xl cht-font-bold !cht-font-heading cht-text-[#1e293b] cht-mb-6 cht-border-b cht-border-slate-100 cht-pb-4">
                            Roles and Responsibilities
                        </h3>
                        <div className="cht-prose cht-max-w-none cht-text-slate-600">
                            {parse(`${detail.roles}`)}
                        </div>
                    </div>
                )}

                <div className="cht-flex cht-justify-center cht-mb-12">
                    <button
                        type="button"
                        disabled={loading}
                        className={`cht-px-8 cht-py-3.5 cht-rounded-xl cht-bg-[#3e57da] hover:cht-bg-[#2f43b5] cht-text-white cht-font-semibold cht-text-base cht-shadow-soft hover:cht-shadow-float cht-transition-all cht-flex cht-items-center cht-gap-2 ${
                            loading ? "cht-opacity-60 cht-cursor-not-allowed" : ""
                        }`}
                        onClick={handleShow}
                    >
                        {loading && <LoaderIcon />}
                        Apply For This Position
                    </button>
                </div>
            </div>

            <MailSubscription />
            <ContactForm />
            {loading ? <PageLoader /> : null}
            <CareerApplicationForm
                show={show}
                onClose={handleClose}
                role={detail.job_title}
                role_id={detail.id}
            />
        </>
    );
};

export default JobOpeningDetail;
